const loc_nl_strings = {
    "Login": {
        "HEADING": "Inloggen FOLBB-ID Platform",
        "LOGIN": "Inloggen",
        "USER": "Gebruikersnaam",
        "PASSWORD": "Wachtwoord",
        "LOGIN_FAIL": "Inloggen mislukt",
        "LOGIN_FIELD_REQUIRED": "Veld \"Gebruikersnaam\" is verplicht",
        "PASSWORD_FIELD_REQUIRED": "Veld \"Wachtwoord\" is verplicht",
        "FORGOT_PASSWORD": "Wachtwoord vergeten?",
        "DIFFERENT_ACCOUNT": "Aanmelden met een ander account",
        "NO_ACCOUNT": "Geen account?",
        "REGISTER": "Registreren bij FOLBB digital\n",
        "CHANGE_DENIED_TEXT": "Gebruik bijv. OWA om uw AD-wachtwoord te wijzigen, of neem contact op met uw ondersteuningsafdeling"
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Acties",
        "CHANGE_PASSWORD_TEXT": "Wachtwoord wijzigen",
        "MY_APPLICATIONS_TEXT": "Mijn FOLBB-toepassingen",
        "APPLICATIONS_TEXT": "FOLBB-toepassingen",
        "USERS_LIST_TEXT": "Gebruikersbeheer"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Mijn FOLBB-toepassingen",
        "APPLICATIONS_TEXT": "FOLBB-toepassingen"
    },
    "Header": {
        "USER_MENU_TEXT": "Gebruikersmenu",
        "ACTION_TEXT": "Acties",
        "CHANGE_PASSWORD_TEXT": "Wachtwoord wijzigen",
        "USERS_LIST_TEXT": "Gebruikersbeheer",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Oud wachtwoord",
        "NEW_PASSWORD": "Nieuw wachtwoord",
        "CONFIRM_PASSWORD": "Wachtwoord bevestigen",
        "PASS_DO_NOT_MATCH": "De wachtwoorden komen niet overeen",
        "PASSWORD_FIELD_REQUIRED": "Veld \"Wachtwoord\" is verplicht",
        "OLD_PASSWORD_FIELD_REQUIRED": "Veld \"Oud wachtwoord\" is verplicht",
        "SUCCESS_TEXT": "Wachtwoord is met succes gewijzigd",
        "HEADING": "Inloggegevens FOLBB-ID wijzigen",
        "HELP": "Hulp nodig?",
        "SAVE": "Wijzigen",
        "CANCEL": "Annuleren",
        "PASSWORD_CHANGE_ERROR": "De gegevens konden niet worden opgeslagen. Probeer het later nog eens",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Wachtwoord moet tenminste uit 10 tekens bestaan en moet een kleine letter, hoofdletter, speciaal teken en cijfer bevatten",
        "PASSWORD_REQUIREMENTS_TEXT": "Wachtwoord moet aan de volgende vereisten voldoen:",
        "LOWERCASE_LETTER_TEXT": "Ten minste één  letter",
        "UPPERCASE_LETTER_TEXT": "Ten minste één hoofdletter",
        "NUMBER_TEXT": "Ten minste één cijfer",
        "SPECIAL_SYMBOL_TEXT": "Ten minste één speciaal teken",
        "PASSWORD_LENGTH_TEXT": "Moet ten minste 10 tekens bevatten",
        "PASSWORD_RESTRICTION_TEXT": "Uw voornaam, achternaam of gebruikersnaam mogen geen deel uitmaken van het wachtwoord",
        "CHANGE_PASSWORD_TEXT": "Wachtwoord wijzigen",
        "ACTION_TEXT": "Acties",
        "CHANGE_DENIED_TEXT": "Gebruik bijv. OWA om uw AD-wachtwoord te wijzigen, of neem contact op met uw ondersteuningsafdeling"
    },
    "CreatePassword": {
        "PASSWORD": "Wachtwoord aanmaken",
        "CONFIRM_PASSWORD": "Uw wachtwoord bevestigen",
        "PASS_DO_NOT_MATCH": "De wachtwoorden komen niet overeen",
        "PASSWORD_FIELD_REQUIRED": "Veld \"Wachtwoord\" is verplicht",
        "SUCCESS_TEXT": "De gegevens zijn met succes opgeslagen",
        "HEADING": "Wachtwoord aanmaken",
        "HELP": "Hulp nodig?",
        "SAVE": "Wijzigen",
        "CANCEL": "Annuleren",
        "PASSWORD_CHANGE_ERROR": "De gegevens konden niet worden opgeslagen. Probeer het later nog eens",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Wachtwoord moet ten minste uit 10 tekens bestaan en moet een kleine letter, hoofdletter, speciaal teken en cijfer bevatten",
        "PASSWORD_REQUIREMENTS_TEXT": "Wachtwoord moet aan de volgende vereisten voldoen:",
        "LOWERCASE_LETTER_TEXT": "Ten minste één letter",
        "UPPERCASE_LETTER_TEXT": "Ten minste één hoofdletter",
        "NUMBER_TEXT": "Ten minste één cijfer",
        "SPECIAL_SYMBOL_TEXT": "Ten minste één speciaal teken",
        "PASSWORD_LENGTH_TEXT": "Moet ten minste 10 tekens bevatten",
        "PASSWORD_RESTRICTION_TEXT": "De voornaam-, achternaam of gebruikersnaam mogen geen deel uitmaken van het wachtwoord",
        "PASSWORD_WAS_SET": "De link werd al gebruikt om een wachtwoord in te stellen. Als u het wachtwoord niet meer weet, gebruik dan de functie wachtwoord opnieuw instellen..",
        "OLD_PASSWORD_REQUIRED": "Veld \"Oud wachtwoord\" is verplicht",
        "MMID_CHANGE_PASSWORD": "Wachtwoord wijzigen",
        "OLD_PASSWORD": "Oud wachtwoord",
        "INVALID_OLD_PASSWORD": "Ongeldig oud wachtwoord",
        "USER_NOT_FOUND_OR_INACTIVE": "Gebruiker niet gevonden of inactief",
        "UNKNOWN_ERROR": "Er is iets verkeerd gegaan bij het wijzigen van het wachtwoord"
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Voer juist e-mailadres in",
        "LOGIN_FIELD_REQUIRED": "\"E-mail\" is een verplicht veld",
        "HEADING": "Wachtwoord vergeten",
        "HELP": "Hulp nodig?",
        "SAVE": "E-mail zenden om wachtwoord opnieuw in te stellen",
        "CANCEL": "Annuleren",
        "SUCCESS_TEXT": "Controleer in uw inbox of u een e-mail ontvangen hebt.",
        "CHANGE_DENIED_TEXT": "Gebruik bijv. OWA om uw AD-wachtwoord te wijzigen, of neem contact op met uw ondersteuningsafdeling.",
        "PASSWORD_RESET_TOO_OFTEN": "De functie wachtwoord opnieuw instellen is te vaak gebruikt, probeer het later nog eens",
        "RESET_FAILED": "Inloggen mislukt",
        "LINK_EXPIRED": "Uw inloglink is verlopen. Vul uw e-mailadres in om de link opnieuw aan te vragen.",
        "HEADING_EXPIRED": "Uw inloglink is verlopen",
        "SAVE_EXPIRED": "Inloglink aanvragen"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gebruikersbeheer",
        "ACTIVE": "Actief",
        "INACTIVE": "Inactief",
        "MMID": "FOLBBID",
        "OU": "Organisatorische eenheid",
        "ORGANIZATION_UNIT": "Organisatie-eenheid",
        "LANGUAGE": "Taal",
        "OPEN_FILTER": "Filter openen",
        "CLOSE_FILTER": "Filter sluiten",
        "RESET": "terugzetten",
        "RESET_ALL_FILTERS": "Alle filters terugzetten",
        "SEARCH": "Zoeken",
        "STATUS": "Status",
        "GROUPS": "Groepen",
        "SHOW_ALL_DETAILS": "Alle gegevens tonen",
        "SHOW_LESS": "Minder tonen",
        "ASCENDING": "Oplopend",
        "DESCENDING": "Aflopend",
        "LIST_END": "Einde van de lijst",
        "SORT_BY_LASTNAME": "Sorteren op achternaam",
        "SORT_BY_FIRSTNAME": "Sorteren op voornaam",
        "SORT_BY_EMAIL": "Sorteren op e-mail",
        "SORT_BY_LANGUAGE": "Sorteren op voorkeurstaal",
        "SORT_BY_STATUS": "Sorteren op status",
        "SORT_BY_OU": "Sorteren op OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Bewerken",
        "CREATE": "Nieuwe gebruiker",
        "DIGICREATE": "Nieuwe FOLBB digital-gebruiker",
        "ACTIVATE": "Activeren",
        "DEACTIVATE": "Deactiveren",
        "USER_WAS_ACTIVATED": "Gebruiker is geactiveerd",
        "USER_WAS_DEACTIVATED": "Gebruiker is gedeactiveerd",
        "ERROR_USER_ACTIVATION": "Fout bij activeren van gebruiker",
        "ERROR_USER_DEACTIVATION": "Fout bij deactiveren van gebruiker",
        "SEND_FORGOT_PW_EMAIL": "Zend e-mail wachtwoord vergeten",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generieke e-mail WW vergeten",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Zend e-mail FOLBB digital WW vergeten",
        "COMPANY": "Bedrijf",
        "SEND_WELCOME_EMAIL": "Zend welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI": "FOLBB digital welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "FOLBB digital welkomstmail zonder WW-knop",
        "APPLY_FILTER_FOR_USERS": "Gebruik de filters of de zoekfunctie om de resultaten weer te geven",
        "GENERATING_EMAIL": "Genererer e-mail ....",
        "ERROR_EMAIL_GENERATE": "Fout bij het genereren van e-mail ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gebruikersbeheer",
        "USER_WAS_ACTIVATED": "Gebruiker is geactiveerd",
        "USER_WAS_DEACTIVATED": "Gebruiker is gedeactiveerd",
        "ERROR_USER_ACTIVATION": "Fout bij activeren van gebruiker",
        "ERROR_USER_DEACTIVATION": "Fout bij deactiveren van gebruiker",
        "LOADING_USER_ERROR": "Fout bij laden van gebruiker",
        "FIRSTNAME": "Voornaam",
        "LASTNAME": "Achternaam",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Naam gebruikerslogin (pre-windows 2000)",
        "LANGUAGE": "Taal",
        "PRINCIPAL_NAME": "Naam gebruikerslogin",
        "OU": "Organisatorische eenheid",
        "CLASS_DISPLAY_NAME": "Weergavenaam",
        "PHONE": "Telefoon",
        "WEBSITE": "Website",
        "COUNTRY": "Land",
        "STATE": "Staat",
        "LOCATION": "Stad",
        "STREET": "Straat",
        "POSTAL_CODE": "Postcode",
        "COMPANY": "Bedrijf",
        "DEPARTMENT": "Afdeling",
        "PERSONAL_TITLE": "Aanspreektitel",
        "MANAGER": "Manager",
        "DESCRIPTION": "Beschrijving",
        "GROUPS": "Groepen",
        "SAVE": "Opslaan",
        "CANCEL": "Annuleren",
        "USER_STATUS": "Gebruikersstatus",
        "ACTIVE": "Actief",
        "INACTIVE": "Inactief",
        "ACTIVATE": "Activeren",
        "DEACTIVATE": "Deactiveren",
        "USER_WAS_SAVED": "Gebruiker is opgeslagen",
        "UNKNOWN_ERROR": "Bij het opslaan van de gebruiker is een onbekende fout opgetreden.",
        "PROXY_ADDRESSES": "Proxy-adressen",
        "BROWSE": "Bladeren",
        "REMOVE": "Verwijderen",
        "ONLY_JPG": "Alleen jpg-afbeeldingen zijn toegelaten!",
        "FILE_SIZE": "Bestand moet kleiner zijn dan 100 kB!",
        "DIMENSIONS": "Maximale grootte afbeeldingen is 96X96 pixels!",
        "SEND_FORGOT_PW_EMAIL": "Zend e-mail wachtwoord vergeten",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generieke e-mail WW vergeten",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail FOLBB digital WW vergeten",
        "VIRUS_FOUND": "De gebruiker kon niet worden opgeslagen. Er is malware gevonden in de bijlage. Het bestand wordt niet geüpload. Neem contact op met uw systeembeheerder.",
        "VIRUS_SCANNER_NOT_AVL": "Het bestand kon niet worden gescand op malware. Probeer het later nog eens. Neem contact op met uw systeembeheerder als het probleem aanhoudt.",
        "INFO": "Over:",
        "SEND_WELCOME_EMAIL": "Zend welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI": "FOLBB digital welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "FOLBB digital welkomstmail zonder WW-knop",
        "SAVING_USER_SPINNER": "Gebruiker opslaan... Wachten",
        "DUPLICATE_USER": "Gebruiker bestaat reeds",
        "GENERATING_EMAIL": "Genererer e-mail ....",
        "ERROR_EMAIL_GENERATE": "Fout bij het genereren van e-mail ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Gebruiker niet gevonden",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Genererer Velkommen e-mail ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Gebruiker is geactiveerd",
        "USER_WAS_DEACTIVATED": "Gebruiker is gedeactiveerd",
        "ERROR_USER_ACTIVATION": "Fout bij activeren van gebruiker",
        "ERROR_USER_DEACTIVATION": "Fout bij deactiveren van gebruiker",
        "EMAIL_WAS_SENT": "E--mail met succes verzonden",
        "EMAIL_NOT_SENT_USER_ACTIVE": "E-mail is niet verzonden. De gebruiker is al actief. Gebruik in plaats daarvan de functie 'Zend e-mail WW vergeten\"",
        "ERROR_EMAIL_SEND": "Fout bij het zenden van de e-mail",
        "EMAIL_NOT_SENT_USER_INACTIVE": "E-mail is niet verzonden. De gebruiker is inactief. Gebruik de functie 'Zend registratie-e-mail FOLBB digital'",
        "PASSWORD_RESET_TOO_OFTEN": "De functie wachtwoord opnieuw instellen is te vaak gebruikt, probeer het later nog eens",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

export default loc_nl_strings;



// WEBPACK FOOTER //
// ./src/resources/nl.js